import { TextSmall } from '@/components/Texts';
import {
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import React from 'react';

export const DataProccessTable = () => {
  return (
    <Stack textAlign={'left'} py={8} align={'start'} w='full'>
      <TextSmall as='span' fontWeight={700}>
        Further data processing:
      </TextSmall>
      <TableContainer whiteSpace={'wrap' as any}>
        <Table fontSize={{ base: 12, md: 14 }}>
          <Thead>
            <Tr>
              <Th>Purpose</Th>
              <Th>Personal Information From You</Th>
              <Th>Personal Information from your devices</Th>
              <Th>Legal Basis</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>
                Administer the website, conduct system administration and
                identify usage patterns, including broad demographic information
                for aggregated use, detection for troubleshooting purposes
              </Td>
              <Td>N/A</Td>
              <Td>
                IP address, browser type, access times, URL requested and
                referral URL, browser type and version, time zone setting,
                browser plug-in types and versions, operating system and
                platform Information about your visit, including the dates and
                times you use the Site, length of visits to certain pages, page
                interaction information
              </Td>
              <Td>
                Legitimate interest in accordance with Art. 6 (1) p. 1 lit. f
                GDPR
              </Td>
            </Tr>
            <Tr>
              <Td>
                Establish and sustain a commercial relationship with you,
                involving the creation and management of your account with us,
                including addressing your requests for account modifications
              </Td>
              <Td>
                First name, last name, email address, username, password,
                country of residence, state/province, time zone
              </Td>
              <Td rowSpan={3}>
                {`Technical information, including the Internet Protocol (IP)
              address used to connect your computer or other device to the
              Internet, browser type and version, time zone setting, browser
              plug-in types and versions, operating system and platform
              Information about your visit, including the dates and times you
              use the Site, length of visits to certain pages, page interaction
              information (such as scrolling, clicks, and mouse-overs), methods
              used to browse away from the page, and any phone number used to
              call the contact phone number provided on our Site IP addresses,
              logs history, a record of all Transaction data for the duration of
              your DC Account's existence`}
              </Td>
              <Td>
                Performance of Contract in accordance with Article 6 para. 1
                lit.b GDPR
              </Td>
            </Tr>
            <Tr>
              <Td>Provide our Services to you</Td>
              <Td>
                User name, email address, Digital Token wallet addresses,
                deposit and withdrawals, deposits addresses, balance history,
                bank statements, bank account numbers, personal information
                posted by user.
              </Td>
              <Td>
                Performance of Contract in accordance with Article 6 para. 1
                lit.b GDPR
              </Td>
            </Tr>
            <Tr>
              <Td>Billing, Invoicing, security requirements </Td>
              <Td>
                Contact details, email address, Digital Token wallet addresses,
                deposit and withdrawals, deposits addresses, balance history,
                bank statements, bank account numbers, personal information
                posted by user.
              </Td>
              <Td>
                Performance of Contract in accordance with Article 6 para. 1
                lit.b GDPR
              </Td>
            </Tr>
            <Tr>
              <Td>
                Compliance, including checking your identity against money
                laundering and terrorist financing, audit, security requirements
                or answering requests by authorities
              </Td>
              <Td>
                Username, email address, full name and contact details, 2 forms
                of ID, picture, signature, bank accounts numbers, proof of
                residence, utility bill, tax statement, service bill,
                certificate of incorporation, business registration, article of
                association, ownership and control structure, directors,
                authorized signatories, authorized signature list, board members
                and director list, name of UBO, certificate of goods standing
              </Td>
              <Td>
                Technical information, including the Internet Protocol (IP)
                address used to connect your computer or other device to the
                Internet, browser type and version, time zone setting, browser
                plug-in types and versions, operating system and platform
                Information about your visit, including the dates and times you
                use the Site, length of visits to certain pages, page
                interaction information (such as scrolling, clicks, and
                mouse-overs), methods used to browse away from the page, and any
                phone number used to call the contact phone number provided on
                our Site
              </Td>
              <Td>
                Compliance with legal requirements and with a legal obligation
                of the controller in accordance with Art. 6 (1) p. 1 lit. c GDPR
              </Td>
            </Tr>
            <Tr>
              <Td>
                Protect the rights, safety and property of us, our clients or
                others
              </Td>
              <Td>
                Any of the Personal Information in this table, taking into
                account necessity and data minimization
              </Td>
              <Td></Td>
              <Td>
                Legitimate interest in accordance with Art. 6 (1) p. 1 lit. f
                GDPR
              </Td>
            </Tr>
            <Tr>
              <Td>Address and resolve the Security Breach, if one occurs</Td>
              <Td>
                Any of the Personal Information in this table, taking into
                account necessity and data minimization and/or all information
                and documents you agreed to provide
              </Td>
              <Td></Td>
              <Td>
                Legitimate interest in accordance with Art. 6 (1) p. 1 lit. f
                GDPR
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
      <TextSmall>
        You can find more information on the actual parties we are at Diment.io.
        The list is updated regularly.
      </TextSmall>
    </Stack>
  );
};
